import { render, staticRenderFns } from "./WhyRestudent.vue?vue&type=template&id=1f3b032e&"
import script from "./WhyRestudent.vue?vue&type=script&lang=js&"
export * from "./WhyRestudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports